import ActionInstructions from '~/apps/account-linking/components/ActionInstructions';
import { P2GBox, P2GButton, P2GGrid, P2GImage, P2GLink, P2GText } from '@parcel2go/core-ui';
import { useAccountLinkingApi } from '~/lib/api/account-linking/use-account-linking-api';
import { useEffect, useState } from 'react';
import { ActionType } from '~/lib/api/account-linking/types';
import { GenerateSourceSquareUrlFromId } from '~/apps/smartsend/lib/helpers/SourceUrlHelper';
import { P2GSidePanel } from '~/components/sidepanel';
import Loading from '~/components/loading/Loading';
import { isLinkOrInstallAction } from './is-link-or-install-action';

type props = {
  integration: string;
  index?: number;
  onHide?: () => void;
  onComplete?: () => void;
};

const MarketplaceActionInstructions = ({
  onComplete,
  integration
}: {
  onComplete: () => void;
  integration: string;
}) => {
  const { getintegrationsummary } = useAccountLinkingApi();
  const [actionType, setActionType] = useState<ActionType>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      const resp = await getintegrationsummary();
      if (resp.success) {
        const integrationData = resp.result.find((i) => i.slug === integration && i.type === 'Marketplace');
        if (integrationData) {
          setActionType(integrationData.accountActions.find((a) => isLinkOrInstallAction(a)));
        }
      }
    };

    fetchData();
  }, [integration]);

  if (!actionType) {
    return (
      <P2GBox textAlign="center" p={4}>
        <Loading />
      </P2GBox>
    );
  }

  return (
    <ActionInstructions
      configRequired={false}
      action={actionType}
      integrationSlug={integration}
      integrationType={'Marketplace'}
      onComplete={onComplete}
      accountId={null}
    />
  );
};

const MarketplaceAction = ({ onComplete, index, onHide, integration }: props) => {
  const [load, setLoad] = useState(false);
  return (
    <>
      <P2GGrid container alignItems="center" gap={2} wrap="nowrap">
        <P2GGrid item>
          <P2GImage
            style={{ width: '40px', height: '40px' }}
            src={GenerateSourceSquareUrlFromId(integration)}
            alt={integration}
          />
        </P2GGrid>
        <P2GGrid item flexGrow={1}>
          <P2GGrid container justifyContent="space-between" alignItems="center" spacing={1} wrap="nowrap">
            <P2GGrid item flexGrow={1}>
              <P2GText>
                <strong>
                  Link {integration} to import your orders <P2GLink onClick={onHide}>Hide</P2GLink>
                </strong>
              </P2GText>
            </P2GGrid>
            <P2GGrid item>
              <P2GButton
                variant={index === 0 ? 'primary' : 'secondary'}
                style={{ minWidth: 'unset', height: 'unset' }}
                onClick={() => setLoad(true)}
              >
                Link
              </P2GButton>
            </P2GGrid>
          </P2GGrid>
        </P2GGrid>
      </P2GGrid>
      <P2GSidePanel open={load} onClose={() => setLoad(false)} anchor="right" width="550px" title={`Link Account`}>
        {load && <MarketplaceActionInstructions integration={integration} onComplete={onComplete} />}
      </P2GSidePanel>
    </>
  );
};
export default MarketplaceAction;
